import { AuthLayout } from "../../pages/auth/AuthLayout";
import { Button, Field } from "../ds";
import { SkeletonScope } from "./SkeletonScope";

/**
 * While the session is being checked we do not know which screen comes next, so this draws the shared
 * card frame (logo, title, two lines, a field and a button) in skeleton mode. Screens with their own
 * data use SkeletonScope around their real layout instead.
 */
export function ScreenSkeleton({ error = false, onRetry }: { error?: boolean; onRetry?: () => void }) {
  if (error) {
    return (
      <AuthLayout title="Não conseguimos falar com a sautria" subtitle="Verifique a internet. Se estiver tudo certo, tente de novo em instantes.">
        <Button type="button" className="auth-block" onClick={onRetry}>
          Tentar de novo
        </Button>
      </AuthLayout>
    );
  }
  return (
    <SkeletonScope loading label="Verificando sua sessão">
      <AuthLayout title="Carregando a sua área" subtitle="Só um instante enquanto verificamos o seu acesso.">
        <div className="auth-form">
          <Field label="E-mail" readOnly aria-label="carregando" />
          <Button type="button" className="auth-block">Continuar</Button>
        </div>
      </AuthLayout>
    </SkeletonScope>
  );
}
